import {CreateView} from '@src/components/_views/configurable/CreateView';
import {withRouterApi} from '@src/HOCs/withRouterApi';
import {FormViewProps} from '@src/@types/components/FormViewProps';
import MaterialForm from './MaterialForm';

export class MaterialCreateForm extends CreateView {
    protected getFormComponent() {
        return MaterialForm;
    }
}

export default MaterialCreateForm.getStoreConnector()(withRouterApi<FormViewProps>(MaterialCreateForm));
